// API keys for background image providers
// This file is gitignored — add your real keys here

export const PEXELS_KEY = PEXELS_API_KEY
export const PIXABAY_KEY = PIXABAY_API_KEY;
// NASA/Hubble does not require an API key for image access

export const UNSPLASH_KEY = UNSPLASH_API_KEY;
